
<template>
  <div>
    <div v-if="to" >
      <router-link :to="to" :class="buttonClass">
        <i class="fa-solid fa-plus create-button-icon"></i>
        <span>{{ label }}</span>
      </router-link>
    </div>
    <div v-else>
      <button  :class="buttonClass">
        <i class="fa-solid fa-plus create-button-icon"></i>
        <span>{{ label }}</span>
      </button>
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  to: {
    type: [String, Object],
    required: false,
  },
  variant: {
    type: String,
    default: 'outline-primary',
  }
});

const buttonClass = computed(() => {
  return `btn btn-${props.variant} create-button`;
});
</script>
<style scoped>
.create-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.create-button-icon {
  font-size: 0.85rem;
}

.create-button:hover {
  transform: translateY(-1px);
}
</style>